import { render, staticRenderFns } from "./RightPartMessage.vue?vue&type=template&id=682e421e&scoped=true"
import script from "./RightPartMessage.vue?vue&type=script&lang=js"
export * from "./RightPartMessage.vue?vue&type=script&lang=js"
import style0 from "./RightPartMessage.vue?vue&type=style&index=0&id=682e421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e421e",
  null
  
)

export default component.exports